import { colors, sizes } from '@lmc/common/constants'
import { Button } from '@lmc/ui-kit'
import { isBrowser, isTablet } from 'react-device-detect'
import styled from 'styled-components'

const isDesktopLayout = isBrowser || isTablet

const Content = styled.div`
  padding: 0 0 50px;
  margin: 0 auto;
  max-width: ${sizes.childScreen}px;
`

const Dashboard = styled.div`
  padding-top: 24px;
`

const ListContainer = styled.div`
  margin-bottom: 40px;
`

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: ${isDesktopLayout ? 'calc(100vw - 290px)' : '100vw'};
`

const ActionButton = styled(Button)`
  text-shadow: none;
  margin-right: 20px;
`

const StartAssessmentButton = styled(ActionButton)`
  float: right;
  margin: 12px 0 0;
`

const StatusIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

const StatusLabel = styled.span`
  padding-right: 10px;
  align-self: center;
  display: block;
  white-space: nowrap;
  text-align: right;
  color: ${colors.black};
`

export const Components = {
  Content,
  Dashboard,
  ListContainer,
  Footer,
  ActionButton,
  StartAssessmentButton,
  StatusIconWrapper,
  StatusLabel
}
